import type { PcMonitorVerdict } from '../../types/pcmonitor.ts';

interface VerdictBadgeProps {
  verdict: PcMonitorVerdict;
  /** Exact pc-monitor hard_filter_failures strings; shown for rejected rows. */
  rejectionReasons: string[];
}

const STYLES: Record<string, string> = {
  qualifying: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  needs_confirmation: 'bg-amber-100 text-amber-800 border-amber-200',
  rejected: 'bg-red-100 text-red-800 border-red-200',
};

const LABELS: Record<string, string> = {
  qualifying: 'Qualifying',
  needs_confirmation: 'Needs confirmation',
  rejected: 'Rejected',
};

/**
 * Verdict pill plus, for rejected rows, the exact rejection reasons. Every
 * filter defect this month was diagnosed from rejected entries, so the
 * reasons ride along wherever a rejected row renders.
 */
export default function VerdictBadge({ verdict, rejectionReasons }: VerdictBadgeProps) {
  const style = STYLES[verdict] ?? 'bg-gray-100 text-gray-700 border-gray-200';
  const label = LABELS[verdict] ?? verdict;
  return (
    <div className="space-y-1">
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${style}`}>
        {label}
      </span>
      {verdict === 'rejected' && rejectionReasons.length > 0 && (
        <ul className="text-xs text-red-700 space-y-0.5">
          {rejectionReasons.map((reason) => (
            <li key={reason} className="font-mono">
              {reason}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
